module.exports = __webpack_public_path__ + "media/en-6043840f.svg";